<div class="modal-box send-email-modal" cdkDrag>
    <div *ngIf="isGeneratingDraft" class="send-email-modal__draft-overlay" role="status" aria-live="polite" aria-label="Generating email draft">
        <i class="fas fa-spinner fa-spin" aria-hidden="true"></i>
    </div>
    <form class="send-email-modal__form modal-form" [formGroup]="emailForm" (ngSubmit)="onSubmit()" (keydown.enter)="onEnterKey($event)">
        <div class="modal-header send-email-modal__header" cdkDragHandle>
            <div class="send-email-modal__headline modal-headline">
                <span class="send-email-modal__eyebrow modal-eyebrow">{{ 'EMAIL' | translate }}</span>
                <h4 class="modal-title send-email-modal__title modal-heading">{{ 'SEND_EMAIL' | translate }}</h4>
            </div>
            <button type="button" class="send-email-modal__close modal-close" [attr.aria-label]="'CLOSE' | translate" (click)="activeModal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body send-email-modal__body">
            <div class="row send-email-modal__layout">
                <div class="col-sm-4 send-email-modal__sidebar" fxLayout="column" fxLayoutAlign="space-between stretch">
                    <div class="send-email-modal__panel send-email-modal__panel--recipients modal-panel">
                        <div class="send-email-modal__field send-email-modal__field--client-picker modal-field">
                            <label class="send-email-modal__label modal-label" for="to">{{ 'TO' | translate }}</label>
                            <ng-select
                                id="to"
                                class="send-email-modal__select modal-select"
                                [items]="allClients"
                                bindLabel="fullName"
                                bindValue="id"
                                [placeholder]="'SELECT_CLIENT' | translate"
                                [clearable]="true"
                                [(ngModel)]="selectedToClientId"
                                (ngModelChange)="onToClientSelected($event)"
                                [ngModelOptions]="{standalone: true}">
                            </ng-select>
                            <div class="send-email-modal__field-input">
                                <input type="text" class="form-control send-email-modal__control modal-control" formControlName="to"
                                    [ngClass]="{ 'is-invalid': submitted && f.to.errors }" [placeholder]="'TO' | translate">
                                <div *ngIf="submitted && f.to.errors" class="invalid-feedback send-email-modal__feedback modal-feedback">
                                    <div *ngIf="f.to.errors.required">{{ 'TO_IS_REQUIRED' | translate }}</div>
                                </div>
                            </div>
                        </div>

                        <div class="send-email-modal__field modal-field">
                            <label class="send-email-modal__label send-email-modal__label--with-action modal-label" for="cc">
                                <span>{{ 'CCS_SEPARATED_WITH_SEMICOLONS' | translate }}</span>
                                <button *ngIf="hasEmployees" type="button" class="send-email-modal__mini-action" (click)="loadEmployeesCc()">{{ 'LOAD_EMPLOYEES' | translate }}</button>
                            </label>
                            <div class="send-email-modal__field-input">
                                <input type="text" class="form-control send-email-modal__control modal-control" formControlName="cc"
                                    [ngClass]="{ 'is-invalid': submitted && f.cc.errors }" [placeholder]="'CCS_SEPARATED_WITH_SEMICOLONS' | translate">
                            </div>
                        </div>

                        <div class="send-email-modal__field modal-field">
                            <label class="send-email-modal__label modal-label" for="replyTo">{{ 'REPLY_TO' | translate }}</label>
                            <div class="send-email-modal__field-input">
                                <input type="text" class="form-control send-email-modal__control modal-control" formControlName="replyTo"
                                    [ngClass]="{ 'is-invalid': submitted && f.replyTo.errors }" [placeholder]="'REPLY_TO' | translate">
                            </div>
                        </div>

                        <div class="send-email-modal__field modal-field">
                            <label class="send-email-modal__label modal-label" for="fromName">{{ 'FROM_NAME' | translate }}</label>
                            <div class="send-email-modal__field-input">
                                <input type="text" class="form-control send-email-modal__control modal-control" formControlName="fromName"
                                    [ngClass]="{ 'is-invalid': submitted && f.fromName.errors }" [placeholder]="'FROM_NAME' | translate">
                            </div>
                        </div>
                    </div>

                    <div class="send-email-modal__panel send-email-modal__panel--note-title modal-panel">
                        <div class="send-email-modal__field modal-field">
                            <label class="send-email-modal__label modal-label" for="title">{{ 'REACH_NOTE_TITLE' | translate }}</label>
                            <ng-select *ngIf="f.title.value === null"
                                id="title"
                                [placeholder]="'NOTE_TITLE' | translate"
                                [items]="sortedEmailTemplates"
                                bindLabel="title"
                                bindValue="title"
                                notFoundText=""
                                [clearable]="true"
                                (search)="onTitleSearch($event)"
                                (blur)="commitTypedTitle()"
                                formControlName="title"
                                class="no-disabled-dropdown send-email-modal__select modal-select"
                                [ngClass]="{ 'is-invalid': submitted && f.title.errors }">
                            </ng-select>
                            <input *ngIf="f.title.value !== null" type="text" class="form-control send-email-modal__control modal-control" formControlName="title"
                                [ngClass]="{ 'is-invalid': submitted && f.title.errors }" [placeholder]="'NOTE_TITLE' | translate">
                            <div *ngIf="submitted && f.title.errors" class="invalid-feedback send-email-modal__feedback modal-feedback">
                                <div *ngIf="f.title.errors.required">{{ 'NOTE_TITLE_IS_REQUIRED' | translate }}</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-sm-8 send-email-modal__main" fxLayout="column" fxLayoutAlign="space-between stretch">
                    <div class="send-email-modal__panel send-email-modal__panel--message modal-panel">
                        <div class="send-email-modal__field send-email-modal__field--subject modal-field">
                            <label class="send-email-modal__label modal-label" for="subject">{{ 'EMAIL_SUBJECT' | translate }}</label>
                            <div class="send-email-modal__field-input">
                                <input type="text" class="form-control send-email-modal__control modal-control" formControlName="subject"
                                    [ngClass]="{ 'is-invalid': submitted && f.subject.errors }" [placeholder]="'EMAIL_SUBJECT' | translate">
                                <div *ngIf="submitted && f.subject.errors" class="invalid-feedback send-email-modal__feedback modal-feedback">
                                    <div *ngIf="f.subject.errors.required">{{ 'SUBJECT_IS_REQUIRED' | translate }}</div>
                                </div>
                            </div>
                        </div>

                        <div class="send-email-modal__field send-email-modal__field--body modal-field">
                            <label class="send-email-modal__label send-email-modal__label--with-action modal-label" for="description">
                                <span>{{ 'EMAIL_BODY' | translate }}</span>
                            </label>
                            <div class="send-email-modal__field-input">
                                <textarea type="text" rows="18" class="form-control send-email-modal__control send-email-modal__control--textarea modal-control modal-control--textarea" formControlName="description"
                                    [ngClass]="{ 'is-invalid': submitted && f.description.errors }"
                                    [placeholder]="'EMAIL_BODY' | translate"></textarea>
                                <div *ngIf="submitted && f.description.errors" class="invalid-feedback send-email-modal__feedback modal-feedback">
                                    <div *ngIf="f.description.errors.required">{{ 'EMAIL_BODY_IS_REQUIRED' | translate }}</div>
                                </div>
                                <div *ngIf="aiRewriteError" class="send-email-modal__ai-error modal-feedback" role="alert">{{ aiRewriteError }}</div>
                            </div>
                        </div>

                        <div *ngIf="false" class="send-email-modal__field send-email-modal__field--attachments">
                            <label class="send-email-modal__label" for="attachment">{{ 'EMAIL_ATTACHMENTS' | translate }}</label>
                            <div class="send-email-modal__field-input">
                                <span>
                                    <ngx-dropzone class="send-email-modal__dropzone" [multiple]="false" (change)="onSelect($event)">
                                    <ngx-dropzone-label>{{ 'DROP_OR_CLICK_TO_UPLOAD' | translate }}</ngx-dropzone-label>
                                    </ngx-dropzone>
                                    <div class="row mb-3 send-email-modal__attachment-row" *ngFor="let file of files">
                                        <div class="col-sm-9">{{ file.name }}</div>
                                        <div class="col-sm-3 send-email-modal__attachment-action">
                                            <a role="button" (click)="onRemove(file)">
                                                <i class="fas fa-trash-can"></i>
                                            </a>
                                        </div>
                                    </div>
                                </span>
                            </div>
                        </div>

                    </div>

                    <div class="send-email-modal__panel send-email-modal__panel--ai modal-panel">
                        <div class="send-email-modal__field send-email-modal__field--ai-prompt modal-field">
                            <label class="send-email-modal__label send-email-modal__label--with-action modal-label" for="aiRewritePrompt">
                                <span>{{ 'AI_REWRITE_INSTRUCTIONS' | translate }}</span>
                                <button
                                    type="button"
                                    class="send-email-modal__mini-action"
                                    (click)="rewriteDescriptionWithAi()"
                                    [disabled]="isRewritingWithAi"
                                    [title]="'AI_REWRITE_TOOLTIP' | translate">
                                    <i class="fas" [ngClass]="isRewritingWithAi ? 'fa-spinner fa-spin' : 'fa-wand-magic-sparkles'" aria-hidden="true"></i>
                                    {{ isRewritingWithAi ? ('AI_REWRITING_EMAIL' | translate) : ('AI_REWRITE_EMAIL' | translate) }}
                                </button>
                            </label>
                            <div class="send-email-modal__field-input">
                                <textarea
                                    id="aiRewritePrompt"
                                    class="form-control send-email-modal__control send-email-modal__control--ai-prompt modal-control"
                                    rows="3"
                                    [(ngModel)]="aiRewritePrompt"
                                    [ngModelOptions]="{standalone: true}"
                                    [disabled]="isRewritingWithAi"
                                    [placeholder]="'AI_REWRITE_PROMPT_PLACEHOLDER' | translate"></textarea>
                            </div>
                        </div>
                        <div class="send-email-modal__field modal-field">
                            <label class="send-email-modal__label modal-label" for="aiRewriteSystemContent">{{ 'AI_REWRITE_SYSTEM_CONTENT' | translate }}</label>
                            <div class="send-email-modal__field-input">
                                <textarea
                                    id="aiRewriteSystemContent"
                                    class="form-control send-email-modal__control send-email-modal__control--ai-prompt modal-control"
                                    rows="4"
                                    [(ngModel)]="aiRewriteSystemContent"
                                    [ngModelOptions]="{standalone: true}"
                                    [disabled]="isRewritingWithAi"
                                    [placeholder]="'AI_REWRITE_SYSTEM_CONTENT' | translate"></textarea>
                            </div>
                        </div>
                        <div class="send-email-modal__ai-options">
                            <div class="send-email-modal__field send-email-modal__field--ai-option modal-field">
                                <label class="send-email-modal__label modal-label" for="aiRewriteModel">Model</label>
                                <div class="send-email-modal__field-input">
                                    <select
                                        id="aiRewriteModel"
                                        class="form-control send-email-modal__control modal-control"
                                        [(ngModel)]="aiRewriteModel"
                                        [ngModelOptions]="{standalone: true}"
                                        [disabled]="isRewritingWithAi">
                                        <option value="gpt-5-mini">GPT-5 mini</option>
                                        <option value="gpt-5">GPT-5</option>
                                        <option value="gpt-5.6-luna">GPT-5.6 Luna</option>
                                        <option value="gpt-5.6-terra">GPT-5.6 Terra</option>
                                    </select>
                                </div>
                            </div>
                            <div class="send-email-modal__field send-email-modal__field--ai-option modal-field">
                                <label class="send-email-modal__label modal-label" for="aiRewriteTemperature">{{ 'AI_REWRITE_TEMPERATURE' | translate }}</label>
                                <div class="send-email-modal__field-input">
                                    <input
                                        id="aiRewriteTemperature"
                                        class="form-control send-email-modal__control modal-control"
                                        type="number"
                                        min="0"
                                        max="1.4"
                                        step="0.1"
                                        [(ngModel)]="aiRewriteTemperature"
                                        [ngModelOptions]="{standalone: true}"
                                        [disabled]="isRewritingWithAi" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal-footer send-email-modal__footer" cdkDragHandle>
            <div *ngIf="submitError" class="send-email-modal__submit-error modal-feedback" role="alert">{{ submitError }}</div>
            <button type="button" class="red-outline-button send-email-modal__button send-email-modal__button--cancel modal-button" (click)="activeModal.close('Close click')">{{ 'CANCEL' | translate }}</button>
            <button type="submit" class="blue-button send-email-modal__button modal-button" [disabled]="isSubmitting">{{ isSubmitting ? ('SENDING_DOTS' | translate) : ('SEND' | translate) }}</button>
        </div>
    </form>
</div>
